import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Row,  } from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getAdminById,
  updateAdmin,
} from "../../../redux/admin/action";
import Spinner from "../../Layouts/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import { updateadmin } from "../../Constant/constant";
import AddUpdateHeader from "../../Common/CardHeader/AddUpdateHeader";
import UpdateAdminRoles from "./UpdateAdminRoles";

const formData = [
  { title: "country_code", name: "country_code" },
  { title: "First Name", name: "first_name" },
  { title: "Last Name", name: "last_name" },
  { title: "Mobile Number", name: "mobile_number" },
  { title: "Email", name: "email_id" },
  { title: "Password", name: "password" },
  { title: "Status", name: "status" },
  { title: "Admin Roles", name: "roles" },
];

const UpdateAdmin = ({ data }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(data?.update);

  const selectedCustomer = useSelector(
    ({ admin: { updateadmin } }) => updateadmin,
  );

  useEffect(() => {
    if (id) {
      dispatch(getAdminById(id));
      setUpdate(true);
    }
  }, [dispatch, id]);

  const initialValues = formData.reduce((acc, field) => {
    acc[field.name] = selectedCustomer?.[field.name] || "";
    return acc;
  }, {});

  const formik = useFormik({
    initialValues,
    onSubmit: (values) => handelSubmit(values),
    enableReinitialize: true,
    validationSchema: updateadmin(update),
  });

  const handleCountryCode = (value, data) => {
    formik.setFieldValue(
      "mobile_number",
      `${value.slice(data.dialCode.length)}`,
    );
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };

  const handelSubmit = async (values) => {

    if (!values.roles) {
      delete values.roles; 
    }
    setLoading(true);
    const data = {
      ...values,
      id: Number(id),
    };
    if (!data.password) {
      delete data.password;
    }
    try {
      await dispatch(updateAdmin(data, setLoading,navigate));
    } catch (error) {
      console.error("Update failed:", error);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="p-3">
      <div className=" category-wrapper">
        <AddUpdateHeader modal={"Update Admin"} list={"Admin List"} />
        <div className="">
          <form onSubmit={formik.handleSubmit}>
            <Row className=" ">
              {formData.map((prop, key) => {
                if (prop.title === "Mobile Number") {
                  return (
                    <Col className="  " key={key} xs={4}>
                      <div className="form-group">
                        <label htmlFor={prop.name}>{(prop.title)}</label>
                        <PhoneInput
                          country={"in"}
                          value={
                            formik?.values.country_code
                              ? `${formik.values.country_code}${formik.values.mobile_number}`
                              : `''`
                          }
                          onChange={(phone, data) =>
                            handleCountryCode(phone, data)
                          }
                          onBlur={() => formik.setFieldTouched(prop.name, true)}
                        />
                      </div>
                      {formik.touched?.[prop.name] &&
                        formik?.errors?.[prop.name] && (
                          <p className="error">
                            {(formik?.errors?.[prop.name])}
                          </p>
                        )}
                    </Col>
                  );
                }
                if (prop.name === "country_code") {
                  return null;
                }
                if (prop.name === "status") {
                  const options = [
                    { value: "1", label: ("Active") },
                    { value: "2", label: ("Inactive") },
                    { value: "4", label: ("Block") },
                  ];

                  return (
                    <Col className="form-group  " key={key} xs={4}>
                      <label>{(prop.title)}</label>
                      <div>
                        <ReactSelect
                          // className='form-control'
                          value={options.find(
                            (option) =>
                              option.value == formik.values?.[prop.name],
                          )}
                          placeholder={(prop.title)}
                          id={prop.name}
                          name={prop.name}
                          options={options}
                          onChange={(selectedOption) =>
                            formik.handleChange(prop.name)(selectedOption.value)
                          }
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched[prop.name] &&
                          formik.errors[prop.name] && (
                            <div className="error">
                              {(formik.errors[prop.name])}
                            </div>
                          )}
                      </div>
                    </Col>
                  );
                }

                if (prop.name === "password") {
                  return (
                    <Col className="  " key={key} xs={4}>
                      <div className="form-group">
                        <label>Password</label>
                        <CustomInput
                          value={formik.values?.[prop.name]}
                          placeholder={(prop.title)}
                          id={prop.name}
                          name={prop.name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          touched={formik.touched}
                          errors={formik.errors}
                        />
                      </div>
                      {formik.touched[prop.name] &&
                        formik.errors[prop.name] && (
                          <div className="error">
                            {(formik.errors[prop.name])}
                          </div>
                        )}
                    </Col>
                  );
                }
                if (prop.name === "roles") {
                  return (
                    <Col className="  " key={key} xs={12}>
                      <UpdateAdminRoles formik={formik} selectedCustomer={selectedCustomer} />
                    </Col>
                  );
                }

                return (
                  <Col className="  " key={key} xs={4}>
                    <div className="form-group">
                      <label>{prop?.title}</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                      />
                    </div>
                    {formik.touched[prop.name] && formik.errors[prop.name] && (
                      <div className="error">{(formik.errors[prop.name])}</div>
                    )}
                  </Col>
                );
              })}
              <Col
                xs={12}
                className="text-center  back-update justify-content-between"
              >
               <button
                    className="back-btn"
                    disabled={loading}
                    onClick={() => navigate("/admin")}
                    type="submit"
                  >
                    Back
                  </button>
                  <button
                    className="submit-btn"
                    disabled={loading}
                    type="submit"
                  >
                    {!loading ? "Submit" : <Spinner />}
                  </button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateAdmin;
